import { Button } from "components/button";
import { Input } from "components/form";
import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { ChevronRightIcon, CloseIcon } from "assets";
import { useClickOutside } from "hooks";

interface RangeFilterProps {
  value:
    | {
        min: string;
        max: string;
      }
    | undefined;
  updateRange: (data: { min: string; max: string } | undefined) => void;
}

export const RangeFilter = ({ value, updateRange }: RangeFilterProps) => {
  const [min, setMin] = useState("");
  const [max, setMax] = useState("");

  const [show, setShow] = useState(false);

  const handleApply = () => {
    if (!!min && !!max) {
      updateRange({ max, min });
      setShow(false);
    }
  };

  const modalRef = useRef(null);
  useClickOutside(modalRef, () => setShow(false));

  useEffect(() => {
    setMax(value?.max ?? "");
    setMin(value?.min ?? "");
  }, [value]);

  return (
    <>
      <div ref={modalRef} className={styles.range}>
        <Button
          type="outline"
          onClick={() => {
            setShow((prev) => !prev);
          }}
          className={value ? styles.active : ""}
        >
          {value ? (
            <>
              {value.max} - {value.min}%{" "}
              <CloseIcon role="button" onClick={() => updateRange(undefined)} />
            </>
          ) : (
            <>Score <ChevronRightIcon className={styles.rotate}  /></>
          )}
        </Button>
        {show ? (
          <div className={styles.popover}>
            <p className={styles.label}>Enter a range</p>
            <div className={styles.inputWrap}>
              <Input
                label="Minimum"
                placeholder="Minimum value"
                name={"min"}
                validatorMessage={undefined}
                className={styles.select}
                parentClassName={styles.selectWrap}
                min={0}
                max={100}
                value={min}
                onChange={(e) => setMin(e.target.value)}
                type="number"
              />
              <Input
                label="Maximum"
                placeholder="Maximum value"
                name={"max"}
                validatorMessage={undefined}
                className={styles.select}
                parentClassName={styles.selectWrap}
                min={0}
                max={100}
                value={max}
                onChange={(e) => setMax(e.target.value)}
                type="number"
              />
            </div>
            <div className={styles.btns}>
              <Button
                disabled={!min || !max}
                type={"transparent"}
                onClick={() => {
                  updateRange(undefined);
                  setShow(false);
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={!min || !max}
                type={"fill"}
                onClick={handleApply}
              >
                Apply
              </Button>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
